module.exports = __webpack_public_path__ + "img/eshop.e85b4c7.svg";